module.exports = __webpack_public_path__ + "img/antes_despues_80.93444fa1.png";